import SEARCH_TYPE from "../constants/SearchBar";

const addZeroIfNumIsLessThanTen = (number) => {
	if (number < 10) return `0${number}`;
	return number;
};

const calculateDateRange = (timeRangeArg) => {
	if (!timeRangeArg) return;

	const timeRange = timeRangeArg.trim();

	const today = new Date();

	const todayDay = today.getDate();
	const todayMonth = today.getMonth();
	const todayYear = today.getFullYear();

	const yesterday = new Date(today);
	yesterday.setDate(yesterday.getDate() - 1);
	const yesterdayDay = yesterday.getDate();
	const yesterdayMonth = yesterday.getMonth();
	const yesterdayYear = yesterday.getFullYear();

	const lastMonth = new Date(
		`${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-01`,
	);
	lastMonth.setMonth(lastMonth.getMonth() - 1);
	const lastMonthMonth = lastMonth.getMonth();
	const lastMonthYear = lastMonth.getFullYear();
	const lastMonthLastDay = new Date(
		today.getFullYear(),
		today.getMonth(),
		0,
	).getDate();

	const returnData = {
		predefinedDates: [],
		startDate: null,
		endDate: null,
		splitType: "month",
		timeRange: timeRange,
		selectedTileID: null,
	};
	const getFormattedDate = (date) => {
		const day = date.getDate();
		const month = date.getMonth();
		const year = date.getFullYear();
		return `${year}-${addZeroIfNumIsLessThanTen(month + 1)}-${addZeroIfNumIsLessThanTen(day)}`;
	};
	const getMonthBoundaries = (monthFromNow) => {
		const date = new Date();
		date.setDate(1);
		date.setMonth(date.getMonth() - monthFromNow);
		const month = date.getMonth();
		const year = date.getFullYear();
		const lastDay = new Date(year, month + 1, 0).getDate();

		return {
			first: `${year}-${addZeroIfNumIsLessThanTen(month + 1)}-01`,
			last: `${year}-${addZeroIfNumIsLessThanTen(month + 1)}-${addZeroIfNumIsLessThanTen(lastDay)}`,
		};
	};
	const getWeekBoundaries = (weekFromNow) => {
		const subDays = 7 * weekFromNow;
		const date = new Date();
		date.setDate(date.getDate() - subDays);
		const dayOfTheWeek = date.getDay();

		let numOfDaysToSubtractToGetFirstDayOfTheWeek = 0;
		let numOfDaysToAddToGetLastDayOfTheWeek = 0;

		switch (dayOfTheWeek) {
			case 0:
				numOfDaysToSubtractToGetFirstDayOfTheWeek = -6;
				numOfDaysToAddToGetLastDayOfTheWeek = 0;
				break;
			case 1:
				numOfDaysToSubtractToGetFirstDayOfTheWeek = 0;
				numOfDaysToAddToGetLastDayOfTheWeek = 6;
				break;
			case 2:
				numOfDaysToSubtractToGetFirstDayOfTheWeek = -1;
				numOfDaysToAddToGetLastDayOfTheWeek = 5;
				break;
			case 3:
				numOfDaysToSubtractToGetFirstDayOfTheWeek = -2;
				numOfDaysToAddToGetLastDayOfTheWeek = 4;
				break;
			case 4:
				numOfDaysToSubtractToGetFirstDayOfTheWeek = -3;
				numOfDaysToAddToGetLastDayOfTheWeek = 3;
				break;
			case 5:
				numOfDaysToSubtractToGetFirstDayOfTheWeek = -4;
				numOfDaysToAddToGetLastDayOfTheWeek = 2;
				break;
			case 6:
				numOfDaysToSubtractToGetFirstDayOfTheWeek = -5;
				numOfDaysToAddToGetLastDayOfTheWeek = 1;
				break;
			default:
				break;
		}

		const firstDayOfTheWeekDate = new Date(date);
		firstDayOfTheWeekDate.setDate(
			firstDayOfTheWeekDate.getDate() +
				numOfDaysToSubtractToGetFirstDayOfTheWeek,
		);

		let lastDayOfTheWeekDate = new Date(date);
		lastDayOfTheWeekDate.setDate(
			lastDayOfTheWeekDate.getDate() + numOfDaysToAddToGetLastDayOfTheWeek,
		);

		if (lastDayOfTheWeekDate > new Date()) {
			lastDayOfTheWeekDate.setDate(
				lastDayOfTheWeekDate.getDate() - numOfDaysToAddToGetLastDayOfTheWeek,
			);
		}

		return {
			first: getFormattedDate(firstDayOfTheWeekDate),
			last: getFormattedDate(lastDayOfTheWeekDate),
		};
	};

	if (timeRange === SEARCH_TYPE.option1) {
		returnData.predefinedDates = [
			{
				startDate: `${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-${addZeroIfNumIsLessThanTen(todayDay)}`,
				endDate: `${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-${addZeroIfNumIsLessThanTen(todayDay)}`,
				id: "today",
			},
			{
				startDate: `${yesterdayYear}-${addZeroIfNumIsLessThanTen(yesterdayMonth + 1)}-${addZeroIfNumIsLessThanTen(yesterdayDay)}`,
				endDate: `${yesterdayYear}-${addZeroIfNumIsLessThanTen(yesterdayMonth + 1)}-${addZeroIfNumIsLessThanTen(yesterdayDay)}`,
				id: "yesterday",
			},
			{
				startDate: `${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-01`,
				endDate: `${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-${addZeroIfNumIsLessThanTen(todayDay)}`,
				id: "month",
			},
			{
				startDate: `${lastMonthYear}-${addZeroIfNumIsLessThanTen(lastMonthMonth + 1)}-01`,
				endDate: `${lastMonthYear}-${addZeroIfNumIsLessThanTen(lastMonthMonth + 1)}-${addZeroIfNumIsLessThanTen(lastMonthLastDay)}`,
				id: "lastMonth",
			},
		];
		returnData.selectedTileID = returnData.predefinedDates[0].id;
		returnData.startDate = returnData.predefinedDates[0].startDate;
		returnData.endDate = returnData.predefinedDates[0].endDate;
	}

	// option2: "Dzisiaj / Wczoraj / Ostatnie 7 dni / Ostatnie 14 dni / Ostatnie 30 dni",
	if (timeRange === SEARCH_TYPE.option2) {
		// get last 7 days date
		const last7Days = new Date(today);
		last7Days.setDate(last7Days.getDate() - 7 - 1);
		const last7DaysDay = last7Days.getDate();
		const last7DaysMonth = last7Days.getMonth();
		const last7DaysYear = last7Days.getFullYear();

		// get last 14 days date
		const last14Days = new Date(today);
		last14Days.setDate(last14Days.getDate() - 14 - 1);
		const last14DaysDay = last14Days.getDate();
		const last14DaysMonth = last14Days.getMonth();
		const last14DaysYear = last14Days.getFullYear();

		//get last 30 days date
		const last30Days = new Date(today);
		last30Days.setDate(last30Days.getDate() - 30 - 1);
		const last30DaysDay = last30Days.getDate();
		const last30DaysMonth = last30Days.getMonth();
		const last30DaysYear = last30Days.getFullYear();

		returnData.predefinedDates = [
			{
				startDate: `${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-${addZeroIfNumIsLessThanTen(todayDay)}`,
				endDate: `${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-${addZeroIfNumIsLessThanTen(todayDay)}`,
				id: "today",
			},
			{
				startDate: `${yesterdayYear}-${addZeroIfNumIsLessThanTen(yesterdayMonth + 1)}-${addZeroIfNumIsLessThanTen(yesterdayDay)}`,
				endDate: `${yesterdayYear}-${addZeroIfNumIsLessThanTen(yesterdayMonth + 1)}-${addZeroIfNumIsLessThanTen(yesterdayDay)}`,
				id: "yesterday",
			},
			{
				startDate: `${last7DaysYear}-${addZeroIfNumIsLessThanTen(last7DaysMonth + 1)}-${addZeroIfNumIsLessThanTen(last7DaysDay)}`,
				endDate: `${yesterdayYear}-${addZeroIfNumIsLessThanTen(yesterdayMonth + 1)}-${addZeroIfNumIsLessThanTen(yesterdayDay)}`,
				id: "last7days",
			},
			{
				startDate: `${last14DaysYear}-${addZeroIfNumIsLessThanTen(last14DaysMonth + 1)}-${addZeroIfNumIsLessThanTen(last14DaysDay)}`,
				endDate: `${yesterdayYear}-${addZeroIfNumIsLessThanTen(yesterdayMonth + 1)}-${addZeroIfNumIsLessThanTen(yesterdayDay)}`,
				id: "last14days",
			},
			{
				startDate: `${last30DaysYear}-${addZeroIfNumIsLessThanTen(last30DaysMonth + 1)}-${addZeroIfNumIsLessThanTen(last30DaysDay)}`,
				endDate: `${yesterdayYear}-${addZeroIfNumIsLessThanTen(yesterdayMonth + 1)}-${addZeroIfNumIsLessThanTen(yesterdayDay)}`,
				id: "last30days",
			},
		];
		returnData.selectedTileID = returnData.predefinedDates[0].id;
		returnData.startDate = returnData.predefinedDates[0].startDate;
		returnData.endDate = returnData.predefinedDates[0].endDate;
	}

	// option3: "Bieżący tydzień / Poprzedni tydzień / Ostatnie 2 tygodnie / Ostatnie 3 tygodnie",
	if (timeRange === SEARCH_TYPE.option3) {
		const { first: firstDayOfCurrentWeek, last: lastDayOfCurrentWeek } =
			getWeekBoundaries(0);
		const { first: firstDayOfLastWeek, last: lastDayOfLastWeek } =
			getWeekBoundaries(1);
		const { first: firstDayOfLast2Weeks, last: lastDayOfLast2Weeks } =
			getWeekBoundaries(2);
		const { first: firstDayOfLast3Weeks, last: lastDayOfLast3Weeks } =
			getWeekBoundaries(3);

		returnData.predefinedDates = [
			{
				startDate: firstDayOfCurrentWeek,
				endDate: lastDayOfCurrentWeek,
				id: "currentWeek",
			},
			{
				startDate: firstDayOfLastWeek,
				endDate: lastDayOfLastWeek,
				id: "lastWeek",
			},
			{
				startDate: firstDayOfLast2Weeks,
				endDate: lastDayOfLast2Weeks,
				id: "last2weeks",
			},
			{
				startDate: firstDayOfLast3Weeks,
				endDate: lastDayOfLast3Weeks,
				id: "last3weeks",
			},
		];
		returnData.selectedTileID = returnData.predefinedDates[0].id;
		returnData.startDate = returnData.predefinedDates[0].startDate;
		returnData.endDate = returnData.predefinedDates[0].endDate;
	}

	// option4: "Obecny miesiąc / Zeszły miesiąc / Ostatnie 2 miesiące / Ostatnie 3 miesiące",
	if (timeRange === SEARCH_TYPE.option4) {
		const { first: startDateOfLastMonth, last: endDateOfLastMonth } =
			getMonthBoundaries(1);
		const { first: startDateOfLast2Month, last: endDateOfLast2Month } =
			getMonthBoundaries(2);
		const { first: startDateOfLast3Month, last: endDateOfLast3Month } =
			getMonthBoundaries(3);

		returnData.predefinedDates = [
			{
				startDate: `${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-01`,
				endDate: `${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-${addZeroIfNumIsLessThanTen(todayDay)}`,
				id: "month",
			},
			{
				startDate: startDateOfLastMonth,
				endDate: endDateOfLastMonth,
				id: "lastMonth",
			},
			{
				startDate: startDateOfLast2Month,
				endDate: endDateOfLast2Month,
				id: "last2months",
			},
			{
				startDate: startDateOfLast3Month,
				endDate: endDateOfLast3Month,
				id: "last3months",
			},
		];
		returnData.selectedTileID = returnData.predefinedDates[0].id;
		returnData.startDate = returnData.predefinedDates[0].startDate;
		returnData.endDate = returnData.predefinedDates[0].endDate;
	}

	// option5: "Dzisiaj / Wczoraj / Ostatnie 2 dni / Ostatnie 3 dni",
	if (timeRange === SEARCH_TYPE.option5) {
		const last2Days = new Date(today);
		last2Days.setDate(last2Days.getDate() - 2);
		const last2DaysDay = last2Days.getDate();
		const last2DaysMonth = last2Days.getMonth();
		const last2DaysYear = last2Days.getFullYear();

		const last3Days = new Date(today);
		last3Days.setDate(last3Days.getDate() - 3);
		const last3DaysDay = last3Days.getDate();
		const last3DaysMonth = last3Days.getMonth();
		const last3DaysYear = last3Days.getFullYear();

		returnData.predefinedDates = [
			{
				startDate: `${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-${addZeroIfNumIsLessThanTen(todayDay)}`,
				endDate: `${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-${addZeroIfNumIsLessThanTen(todayDay)}`,
				id: "today",
			},
			{
				startDate: `${yesterdayYear}-${addZeroIfNumIsLessThanTen(yesterdayMonth + 1)}-${addZeroIfNumIsLessThanTen(yesterdayDay)}`,
				endDate: `${yesterdayYear}-${addZeroIfNumIsLessThanTen(yesterdayMonth + 1)}-${addZeroIfNumIsLessThanTen(yesterdayDay)}`,
				id: "yesterday",
			},
			{
				startDate: `${last2DaysYear}-${addZeroIfNumIsLessThanTen(last2DaysMonth + 1)}-${addZeroIfNumIsLessThanTen(last2DaysDay)}`,
				endDate: `${last2DaysYear}-${addZeroIfNumIsLessThanTen(last2DaysMonth + 1)}-${addZeroIfNumIsLessThanTen(last2DaysDay)}`,
				id: "last2days",
			},
			{
				startDate: `${last3DaysYear}-${addZeroIfNumIsLessThanTen(last3DaysMonth + 1)}-${addZeroIfNumIsLessThanTen(last3DaysDay)}`,
				endDate: `${last3DaysYear}-${addZeroIfNumIsLessThanTen(last3DaysMonth + 1)}-${addZeroIfNumIsLessThanTen(last3DaysDay)}`,
				id: "last3days",
			},
		];
		returnData.selectedTileID = returnData.predefinedDates[0].id;
		returnData.startDate = returnData.predefinedDates[0].startDate;
		returnData.endDate = returnData.predefinedDates[0].endDate;
	}

	//cOption1: "Ostatnie 12 miesięcy, miesięcznie",
	if (timeRange === SEARCH_TYPE.cOption1) {
		const last12Months = new Date(today);
		last12Months.setMonth(last12Months.getMonth() - 11);

		const last12MonthsMonth = last12Months.getMonth();
		const last12MonthsYear = last12Months.getFullYear();

		returnData.startDate = `${last12MonthsYear}-${addZeroIfNumIsLessThanTen(last12MonthsMonth + 1)}-01`;
		returnData.endDate = `${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-${addZeroIfNumIsLessThanTen(todayDay)}`;
		returnData.splitType = "month";
	}

	//cOption2: "Ostatnie 3 miesiące, tygodniowo",
	if (timeRange === SEARCH_TYPE.cOption2) {
		const last3Months = new Date(today);
		last3Months.setMonth(last3Months.getMonth() - 2);

		const last3MonthsMonth = last3Months.getMonth();
		const last3MonthsYear = last3Months.getFullYear();

		returnData.startDate = `${last3MonthsYear}-${addZeroIfNumIsLessThanTen(last3MonthsMonth + 1)}-01`;
		returnData.endDate = `${todayYear}-${addZeroIfNumIsLessThanTen(todayMonth + 1)}-${addZeroIfNumIsLessThanTen(todayDay)}`;
		returnData.splitType = "week";
	}

	//cOption3: "Ostatnie 30 dni, dziennie",
	if (timeRange === SEARCH_TYPE.cOption3) {
		const last30Days = new Date(today);
		last30Days.setDate(last30Days.getDate() - 30 - 1);
		const last30DaysDay = last30Days.getDate();
		const last30DaysMonth = last30Days.getMonth();
		const last30DaysYear = last30Days.getFullYear();

		returnData.startDate = `${last30DaysYear}-${addZeroIfNumIsLessThanTen(last30DaysMonth + 1)}-${addZeroIfNumIsLessThanTen(last30DaysDay)}`;
		returnData.endDate = `${yesterdayYear}-${addZeroIfNumIsLessThanTen(yesterdayMonth + 1)}-${addZeroIfNumIsLessThanTen(yesterdayDay)}`;
		returnData.splitType = "day";
	}

	return returnData;
};

export { addZeroIfNumIsLessThanTen, calculateDateRange };
